<template>
  <div>
    <div v-if="autoProlongationAlreadyEnabled && savedPaymentMethod" class="alert alert-info">
      <p>Включено автопродление членства. Членский взнос будет списан с карты <code>{{ savedPaymentMethod.first6 }} *** {{ savedPaymentMethod.last4 }}</code>, действительной до {{ savedPaymentMethod.tillMonth | fillLeadingZeroes(2) }}/{{ savedPaymentMethod.tillYear }}, при истечении членства.</p>
      <button class="btn btn-default btn-sm" @click="disableAutoprolongation">Отключить автопродление</button>
    </div>
    <h3 v-if="!open">
        <button class="btn btn-primary btn-lg btn-block" @click.prevent="setVisibleForm" :disabled="isButtonDisabled">{{ buttonCaption }}</button>
        <div class="prolongation-disabled-comment" v-if="isButtonDisabled"><a href="#" @click.prevent="disableAutoprolongation">Отключите автопродление членства</a> для продления членства вручную</div>
    </h3>

    <div class="form-group" v-if="memberStatus === 'was_member' && deltaMonthMore3">
      <small class="form-text text-info">
        Вы являетесь членом АОПА с {{ startDate }} года, и эта дата пишется на членской карте.
        У вас членство закончилось с {{ finDate }} года. Сейчас вы можете либо продлить членство с {{ finDate }}
        и сохранить номер членской карты либо вступить в организацию заново.
        В случае вступления заново срок членства будет исчисляться с текущей даты и вы получите новый номер членской карты.
      </small>
    </div>

    <form novalidate @submit.prevent="submit" v-if="visibleForm || open">
      <div class="form-group input-group-sm mt-1"><!-- term -->
        <label for="term">Способ получения членской карты:</label>
        <select class="form-control" v-model="cardReceive">
          <option value="personally">лично в офисе АОПА</option>
          <option value="post">отправить на почтовый адрес</option>
        </select>
      </div>

      <div class="form-check" v-if="mayEntrance">
        <input class="form-check-input" type="radio" name="exampleRadios" id="entrance" value="entrance" v-model="sel">
        <label class="form-check-label" for="entrance">
          Вступление
        </label>
      </div>
      <div class="form-check" v-if="mayProlong">
        <input class="form-check-input" type="radio" name="exampleRadios" id="prolongation" value="prolongation" v-model="sel">
        <label class="form-check-label" for="prolongation">
          Продление членства
        </label>
      </div>

      <template v-if="prolongs[term].discountPossible"><!-- discount -->
        <div class="form-group form-check" >
          <template v-if="prolongs[term].groupRequestPossible">
          <input type="checkbox" class="form-check-input" id="discount" v-model="group" @change="setGroup()">
          <label class="form-check-label" for="discount">Скидка 50% (групповое членство)</label>
          <br>
          </template>
          <input type="checkbox" class="form-check-input" id="discount2" v-model="discount" @change="setDiscount()">
          <label class="form-check-label" for="discount2">Скидка 50% (<a href="https://aopa.ru/index.php?id=72" target="_blank">льготная категория</a>)</label>
        </div>
      </template>

      <template v-if="group"> <!-- organizer -->
        <div class="alert alert-info">
          <p>В группе должно быть не менее 5-ти человек (включая организатора).</p>
          <p>Обработка заявок и выдача ID-карт начнётся после внесения членских взносов всеми участниками.</p>
        </div>

        <div class="form-group form-check mb-0 pb-0">
          <input type="checkbox" class="form-check-input" id="i-organizer" v-model="iAmOrganizer" @change="setOrganizer">
          <label class="form-check-label" for="i-organizer">Я — организатор группы</label>
        </div>

        <Input
          type="text"
          caption="Фамилия и имя организатора группы:"
          :maxLength="255"
          :small="true"
          bgColor="azure"
          :hideTextLength="true"
          :value="organizer"
          @on-input="organizerInput"
          :isError="invalidValue(organizerError)"
          :textError="errorTextOrganizer"
          :disabled="iAmOrganizer"
        />
        <small class="text-info" v-if="iAmOrganizer">
          Остальные участники группы должны ввести <em>{{ this.getUserName() }}</em> в качестве организатора группы
        </small>
      </template>

      <div class="input-group input-group mb-3" v-if="askForDocument">
        <div class="col-11"><label>Загрузите подтверждающий документ</label></div>
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupFileAddon01">файл:</span>
        </div>
        <div class="custom-file">
          <input
            type="file"
            :class="[ fileInvalid ? 'is-invalid' : '', 'custom-file-input' ]"
            id="inputGroupFile01"
            aria-describedby="inputGroupFileAddon01"
            @change="loadDoc"
          />
          <label class="custom-file-label" for="inputGroupFile01">
            {{ documentName }}
          </label>
        </div>
      </div>

      <div class="form-group input-group-sm mt-1" v-if="group && iAmOrganizer"><!-- term -->
        <label for="groupMembersCount">Число участников группы (включая организатора)</label>
        <div>
          <input type="number"
                 id="groupMembersCount"
                 v-model="groupMembersCount"
          />
        </div>
        <small class="text-info" v-if="iAmOrganizer">
          Обработка заявок начнётся после заполнения анкетных данных и внесения членских взносов всеми участниками группы
        </small>
      </div>

      <div class="form-group input-group-sm mt-1"><!-- term -->
        <label for="term">{{ textMembershipTerm }}</label>
        <select class="form-control" id="term" v-model="term">
          <option
            v-for="(prolong, index) in prolongs"
            :key="index"
            :value="index">
            {{ prolong.title }}
          </option>
        </select>
      </div>

      <div class="form-group input-group-sm mt-1"> <!-- price -->
        <label for="price">Стоимость, руб:</label>
        <input type="text" class="form-control" id="price" :value="price" disabled>
      </div>

      <div class="form-group form-check" v-if="group">
          <input type="checkbox" class="form-check-input" id="do-not-redirect" v-model="doNotRedirect">
          <label class="form-check-label" for="do-not-redirect">Не перенаправлять меня на страницу оплаты, оплату осуществит другой участник группы</label>
      </div>

      <template v-if="isAutoProlongationPossible">
      <div class="form-group form-check" v-if="isAutoProlongationPossible">
          <input type="checkbox" class="form-check-input" id="auto-prolongation-checkbox" v-model="autoProlongationEnabled">
          <label class="form-check-label" for="auto-prolongation-checkbox">{{ autoProlongationTitle }}</label>
      </div>
      <div class="form-group" v-if="autoProlongationEnabled">
        <small class="form-text text-info">
          Соглашаясь на автоматическое продление, вы разрешаете АОПА-Россия списывать членский взнос при истечении предыдущего членства. Данное разрешение действует до его отмены. Перед автопродлением мы вас уведомим по электронной почте - вы можете отменить автоматическое продление в любой момент.
        </small>
      </div>
      </template>

      <div class="form-group"> <!-- button pay -->
        <button class="btn btn-primary" type="button" disabled v-if="showWait && !doNotRedirect">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Перенаправление...
        </button>
        <button type="submit" class="btn btn-primary" v-else>
          {{ textButtonPay }}
        </button>
      </div>

      <div class="form-group" v-if="!extensionPeriodSuccess && sel === 'prolongation'">
        <small class="form-text text-danger">
          Выбранного периода продления недостаточно для изменения статуса на активного члена АОПА!
        </small>
      </div>

      <div class="form-group">
        <small class="form-text text-info">
          Оплата производится по QR-коду через систему быстрых платежей (СБП) или банковской картой.
        </small>
      </div>
    </form>
  </div>
</template>

<script>
import { getPrice } from '@/utils/MembershipPayment.js'
import { PROLONG_VARIANTS } from '@/utils/amo/constants.js';
import { minLength, testDate } from '@/utils/Validate.js'
import { convertYMDtoDMY } from '@/utils/convertor.js'
// import { v4 as generateID } from 'uuid';
import Input from '@/components/Input.vue'
import fillLeadingZeroes from '@/utils/amo/fillLeadingZeroes.js'
import { doShowPaymentModal } from '@/utils/MembershipPayment.js';

export default {
  components: {
    Input
  },
  props: {
    memberStatus: String,
    accept: Boolean,
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const variant = 1;
    return {
      visibleForm: false,
      term: variant,            // select
      price: PROLONG_VARIANTS[variant].price,
      group: false,
      discount: false,
      showWait: false,
      groupMembersCount: null,
      document: '',
      fileInvalid: false,
      organizer: '',
      organizerError: {
        minLength: false,
        wrongData: false,
      },
      sel: '',              // entrance / prolongation
      beginDate: this.$store.getters.getUserData.memberInfo?.membership_begin_date,
      endDate: this.$store.getters.getUserData.memberInfo?.membership_end_date,
      autoProlongationAlreadyEnabled: this.$store.getters.getUserData.memberInfo?.isAutoProlongationEnabled,
      savedPaymentMethod: this.$store.getters.getUserData.memberInfo?.savedPaymentMethod,
      doNotRedirect: false,
      autoProlongationEnabled: true,
      iAmOrganizer: false,
      cardReceive: 'post',
    }
  },
  watch: {
    term: function() {
      if (this.student) {
        this.discount = true
        this.group = false
      }

      if (!this.prolongs[this.term].discountPossible && !this.student) {
        this.discount = false
        this.group = false
      }

      this.setPrice()
    },
    group: function() {
      this.setPrice()
    },
    discount: function() {
      this.setPrice()
    },
    accept: function() {
      this.visibleForm = false
    },
  },
  mounted() {
    if (this.mayProlong) {
      this.sel = 'prolongation'
    } else {
      this.sel = 'entrance'
    }
    this.setPrice()
  },
  computed: {
    buttonCaption() {
      switch(this.memberStatus) {
        case 'was_member':
              return 'Ваше членство АОПА-Россия истекло';
        case 'active_member':
              return 'Продлить членство в АОПА-Россия';
        case 'other_member':
        default:
              return 'Стать членом АОПА-Россия';
      }
    },
    isButtonDisabled() {
      return this.autoProlongationAlreadyEnabled && this.savedPaymentMethod;
    },
    student() {
       return this.term === 0;
    },
    askForDocument() {
       return this.student || this.discount;
    },
    documentRequired() {
       return this.student || (this.discount && (this.age < 65));
    },
    isAutoProlongationPossible() {
      if (this.group) {
        return false;
      }

      if (this.discount) {
        return false;
      }

      if (this.student) {
        return false;
      }

      return (this.leadPeriodYears == 1);
    },
    autoProlongationTitle() {
      if (this.leadPeriodYears == 1) {
        return 'Автоматически ежегодно продлять членство';
      }

      return null;
    },
    dateOfBirth() {
      return this.$store.getters.getUserData.memberInfo?.birthdate || '1970-01-01'
    },
    age() {
      try {
        const dt = Date.parse(this.dateOfBirth);
        const now = new Date();
        if (isNaN(dt)) {
          return null;
        }
        return now.getFullYear() - dt.getFullYear();
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    leadPeriodYears() {
      return this.prolongs[this.term].leadPeriodYears;
    },
    prolongs() {
      return PROLONG_VARIANTS
    },
    documentName() {
      return (this.document.name) ? this.document.name : 'файл не выбран'
    },
    errorTextOrganizer() {
      if (this.organizerError.minLength) return "Поле не должно быть пустым!"
      if (this.organizerError.wrongData) return "Фамилия и имя организатора кириллицей, через пробел"
      return "";
    },
    deltaMonthMore3() { // прошло ли 3 месяца с завершения членства
      if (testDate(this.endDate)) {
        const d = this.endDate.split('-')
        const endDate = new Date(d[0], parseInt(d[1]) + 3, d[2], 23, 59, 59)
        const now = Date.now()

        return endDate - now < 0
      }
      return true
    },
    startDate() {
      return convertYMDtoDMY(this.beginDate)
    },
    finDate() {
      return convertYMDtoDMY(this.endDate)
    },
    extensionPeriodSuccess() { // завершено членство или нет
      if (testDate(this.endDate)) {
        const d = this.endDate.split('-')
        const leadPeriodYears = this.prolongs[this.term].leadPeriodYears
        const date = new Date(parseInt(d[0]) + leadPeriodYears, d[1], d[2], 23, 59, 59)
        const now = Date.now()

        return date - now > 0
      }
      return false
    },
    textMembershipTerm() {
      if (this.sel === 'prolongation') return 'Срок продления членства после ' + this.finDate + ':'
      return 'Срок членства:'
    },
    textButtonPay() {
      return (this.doNotRedirect) ? 'Отправить заявку' : 'Оплатить'
    },
    mayProlong() {
      return this.memberStatus === 'was_member' || this.memberStatus === 'active_member';
    },
    mayEntrance() {
      if (this.memberStatus === 'active_member') {
        return false;
      }

      if (this.memberStatus === 'was_member' && !this.deltaMonthMore3) {
        return false;
      }

      return true;
    }
  },
  methods: {
    invalidValue(obj) {           // Проверяем значение на ошибки
      for (let key in obj) {
        if (obj[key]) return true
      }
      return false
    },
    setVisibleForm() {
      if (!this.accept) {
        this.$store.commit('setDataToast', { state: 0, text: 'Необходимо заполнить все данные, включая фото' })
        return
      }
      this.visibleForm = true
    },
    setPrice() {
      let group = false
      if (this.group || this.discount ) group = true
      this.price = getPrice(this.prolongs[this.term], { student: this.student, group: group })
    },
    setGroup() {
      if (this.discount) this.discount = false
    },
    setDiscount() {
      if (this.group) this.group = false
    },
    loadDoc(e) {
      if (e.target.files[0]) {
        this.document = e.target.files[0]
        this.fileInvalid = false
      } else {
        this.document = ''
      }
    },
    organizerInput(value) {
      this.organizerError.minLength = minLength(value)
      this.organizerError.wrongData = false
      this.organizer = value.trim()
    },
      // проверяем, что строка содержит Фамилию + Имя
    testFN(value) {
      const reg = /^\s*[а-яА-ЯёЁ]+(-[а-яА-ЯёЁ]+)?\s+[а-яА-ЯёЁ]+\s*$/
      return reg.test(value);
    },
    submit() {
      if (!this.document && this.documentRequired) {
        this.fileInvalid = true
        this.$store.commit('setDataToast', { state: 0, text: 'Необходимо загрузить файл!' })
        return
      }

      if (this.group) {
        this.organizerError.minLength = minLength(this.organizer)
        this.organizerError.wrongData = !this.testFN(this.organizer)

        if (this.invalidValue(this.organizerError)) {
          this.$store.commit('setDataToast', { state: 0, text: 'Необходимо заполнить фамилию и имя организатора!' })
          return
        }

        if (this.iAmOrganizer && this.groupMembersCount < 5) {
          this.$store.commit('setDataToast', { state: 0, text: 'В группе должно быть не менее пяти участников' })
          return
        }
      }

      if (this.sel === '') {
        this.$store.commit('setDataToast', { state: 0, text: 'Необходимо выбрать способ продления' })
        return
      }

      // оплата
      //this.showWait = true
      const formData = new FormData()
      formData.append('leadPeriodYears', this.prolongs[this.term].leadPeriodYears)
      formData.append('price', this.price)
      formData.append('student', this.student)
      formData.append('group', this.group)
      formData.append('discount', this.discount)
      formData.append('document', this.document)
      formData.append('age', this.age)
      if (this.iAmOrganizer) {
        formData.append('organizer', this.getUserName())
      } else {
        formData.append('organizer', this.organizer)
      }
      formData.append('typeOfMembership', this.sel)
      formData.append('doNotRedirect', this.doNotRedirect)
      formData.append('iAmOrganizer', this.iAmOrganizer)
      formData.append('cardReceive', this.cardReceive)
      formData.append('groupMembersCount', this.groupMembersCount)
      if (this.isAutoProlongationPossible) {
        formData.append('autoProlongationEnabled', this.autoProlongationEnabled)
      }

      const requestId = Date.now().toString();
      formData.append('requestId', requestId)

      this.$store.dispatch('payEntry', formData)
      .then(() => {
        if (this.doNotRedirect && this.group) { // если пользователь установил опцию "оплачу позже", то просто обновляю информацию
          this.$store.dispatch('loginWithCookie')
        } else { // если пользователь не установил флаг "оплачу позже", то делаем запрос на API оплаты, передавая id заявки, которую нужно оплатить
          const requestData = { requestId };

          if (this.isAutoProlongationPossible) {
            requestData['autoProlongationEnabled'] = this.autoProlongationEnabled;
          }

          doShowPaymentModal(requestData);
        }
      })
      .catch(()=>{})
    },
    setOrganizer() {
      if (this.iAmOrganizer) {
        this.organizer = this.getUserName()
        this.organizerError.minLength = minLength(this.organizer)
        this.organizerError.wrongData = !this.testFN(this.organizer)
      } else {
        this.organizer = ''
      }
    },
    getUserName() {
      return this.$store.getters.getUserData.memberInfo.lastname + " " + this.$store.getters.getUserData.memberInfo.firstname
    },
    disableAutoprolongation() {
      if (confirm('Отключить автопродление членства?')) {
        this.$store.dispatch('disableAutoprolongation', this.savedPaymentMethod)
      }
    },
  },
  filters: {
    fillLeadingZeroes
  }
}
</script>

<style scoped>
  .custom-file {
    overflow: hidden;
    white-space: nowrap;
  }

  .prolongation-disabled-comment {
    font-size: 12px;
    padding-top: 10px;
  }
</style>>

